// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1t-iv","clinicsSelect":"TableHeading_clinicsSelect__3iXQ4"};